// extracted by mini-css-extract-plugin
module.exports = {"profileContainer":"ProfileContainer_profileContainer__2T27j","fullName":"ProfileContainer_fullName__UBi2x"};